import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { SalaryTypeActions } from '../State/actions/salary-type.actions';
import { getSalaryTypeFetched } from '../State/selectors/salary-type.selector';
import { BaseEntityResolver } from './resolver.helper';

@Injectable({
    providedIn: 'root',
})
export class SalaryTypeResolver extends BaseEntityResolver {
    constructor(store: Store<State>) {
        super(getSalaryTypeFetched, SalaryTypeActions.load({ Payload: {} }), store);
    }
}
